import z from 'zod';

export const ValidateCreateVacanciesTemplateSchema = z
  .object({
    name: z.string().min(1, 'Название вакансии обязательно'),
    currencyId: z
      .string({ message: 'Выберите валюту' })
      .min(1, 'Выберите валюту'),
    salaryFrom: z
      .number({ message: 'Введите минимальную зарплату' })
      .min(1, 'Зарплата должна быть больше 0'),
    salaryTo: z
      .number({ message: 'Введите максимальную зарплату' })
      .min(1, 'Зарплата должна быть больше 0'),
    mandatoryRequirements: z
      .string()
      .min(1, 'Обязательные требования необходимы'),
    additionalRequirements: z
      .string()
      .min(1, 'Дополнительные требования необходимы'),
    responsibilities: z.string().min(1, 'Обязанности необходимы'),
    paymentPeriodId: z
      .string({ message: 'Выберите период выплат' })
      .min(1, 'Выберите период выплат'),
    employmentTypeIds: z
      .array(z.string(), { message: 'Выберите хотя бы один тип занятости' })
      .min(1, 'Выберите хотя бы один тип занятости'),
    scheduleWorkIds: z
      .array(z.string(), { message: 'Выберите график работы' })
      .min(1, 'Выберите график работы'),
    skills: z.array(z.string()).optional(),
  })
  .refine(data => data.salaryTo >= data.salaryFrom, {
    message: 'Максимальная зарплата должна быть больше или равна минимальной',
    path: ['salaryTo'],
  });

export type VacanciesTemplatesFormValues = {
  name: string;
  currencyId: string;
  salaryFrom: number | undefined;
  salaryTo: number | undefined;
  mandatoryRequirements: string;
  additionalRequirements: string;
  responsibilities: string;
  employmentTypeIds: string[];
  paymentPeriodId: string;
  scheduleWorkIds: string[];
  skills: string[];
};
